import {
	btn,
	checkbox,
	CheckboxField,
	comp,
	Component,
	fieldset,
	Notifier,
	router,
	tbar,
	win,
	Window
} from "@intermesh/goui";
import {t} from "./util/Translate.js";
import {registrationForm} from "./components/RegistrationForm.js";
import {LanguageEntity} from "./data/LanguagesStore.js";
import {CurrentParticipant} from "./services/CurrentParticipant.js";
import {ServerApi} from "./util/ServerApi.js";
import {IfwInvalidator} from "./util/IfwInvalidator.js";

export class Register extends Component {
	private Notifier: any;

	constructor() {
		super("section");
		this.itemId = "register";
		this.id = "register";
		this.cls = "card";

		const p = registrationForm({readOnly: false});

		p.form.on("submit", () => {
			let cp = CurrentParticipant.get();
			delete cp.agreedTerms;
			delete cp.user!.passwordRepeat;

			const url = ServerApi.url("elearning/frontend/participants/validate", {});
			ServerApi.call(url, cp, "POST").then((result) => {
				if (result.success) {
					void router.goto("confirm-registration");
				} else {
					// Should not happen
					Notifier.warning(t("There was an unknown error. Please check your inpout"))
					return false;
				}
			}).catch((reason) => {
				if(reason.type == "invalidProperties") {
					Object.entries(reason.validationErrors).forEach(([key, value]: [string, any]) => {
						if (key === "username") {
							p.usernameFld.setInvalid(t("Sorry, this username is already taken"));
						} else if (key === "email") {
							p.emailFld.setInvalid(t(value.description));
						} else {
							IfwInvalidator.setInvalidPasswordMessage(p.passwordFld, reason.validationErrors[key]);
						}
					});
				} else {
					void Window.error(reason);
				}
				return false;
			})
		});

		const pc = JSON.parse(localStorage.getItem("portalConfig")!);

		Promise.all([p.load(), CurrentParticipant.readIf()])
			.then(async ([_res1, res2]) => {
				this.items.add(p);
				// const lang = await languageDS.single(res2.languageId || sessionStorage.getItem("languageId")!);
				const languageId = res2.languageId || sessionStorage.getItem("languageId");
				const lang = JSON.parse(localStorage.getItem("lang_" + languageId)!);
				if (lang!.generalTerms && !res2.userId) {
					if (pc.mustAcceptTerms) {
						p.form.items.add(fieldset({},
							checkbox({
								name: "agreedTerms",
								required: true,
								label: `${t("I accept the")} ${t("privacy policy")}`,
								listeners: {
									invalid: ({target}) => {
										if (!target.isValid()) {
											target.invalidMsg = t("You must agree to continue");
										}
										return false;
									}
								},
								buttons: [
									btn({
										cls: "outlined",
										icon: "shield", handler: () => {
											this.showTerms(lang!);
										}, text: t("Privacy policy")
									})
								]
							}))
						);
					} else {
						const p = comp({/*cls: "ifw-center"*/cls: "pad"},
							btn({
								cls: "outlined",
								icon: "shield",
								handler: () => {
									this.showTerms(lang!)
								}, text: t("Privacy policy")
							})
						);
						this.items.add(p);
					}
				}


				this.items.add(tbar({cls: "ifw-bbar"},
					btn({text: t("Back"), route: ""}),
					"->",
					btn({
						type: "submit", text: t("Continue"), handler: () => {
							p.form.submit();
						}
					})
				));
			});
	}

	private showTerms(lang: LanguageEntity) {
		win({
			title: t("Terms and conditions"),
			modal: false,
			resizable: true,
			maximizable: false,
			draggable: true,
			width: 800,
			height: 600
		}, comp({cls: "pad fit scroll", html: lang!.generalTerms}))
			.show();
	}
}
